var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSenegal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6957 1.98447C26.0663 0.713064 23.1165 -6.10352e-05 20.0001 -6.10352e-05C16.8837 -6.10352e-05 13.9338 0.713064 11.3044 1.98447L9.56531 19.9999L11.3044 38.0154C13.9338 39.2868 16.8837 39.9999 20.0001 39.9999C23.1165 39.9999 26.0663 39.2868 28.6957 38.0154L30.4348 19.9999L28.6957 1.98447Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 13.0435L21.7265 18.3575H27.3146L22.794 21.6421L24.5206 26.9564L19.9999 23.672L15.4792 26.9564L17.2062 21.6421L12.6855 18.3575H18.2733L19.9999 13.0435Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3044 1.98523C4.61459 5.22015 6.10352e-05 12.0709 6.10352e-05 20C6.10352e-05 27.9291 4.61459 34.7798 11.3044 38.0148V1.98523Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6956 1.98517V38.0147C35.3854 34.7798 40 27.9291 40 19.9999C40 12.0708 35.3854 5.22009 28.6956 1.98517Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSenegal);
export default __webpack_public_path__ + "static/media/senegal.71e28e8b2174f95e432720f74971f8f6.svg";
export { ForwardRef as ReactComponent };